import React from 'react';
import image from '../Pages/image/logo.png'
import { HashLink as Link } from 'react-router-hash-link';
const Navbar = () => {
    return (
        <div>
            <div class="navbar menu-background fixed shadow ">
               
                <div class="navbar-start">
                    <a class="btn btn-ghost normal-case text-xl"><img className='h-10'  src={image} alt="" /></a>
                </div>
              
                <div class="navbar-end">
                    
                    <button class="ease-in-out  duration-300 inline-flex text-white bg-cyan-500 border-0 py-2 px-3 focus:outline-none hover:bg-cyan-400 rounded text-lg"> <a  href='https://drive.google.com/file/d/1L0WWmKsqoEYAAlEZF8ILvwXTs_5nXEYT/view?usp=sharing' target="_blank" rel='noopener noreferrer'>Resume</a></button>
                </div>
             
            </div>
        </div>
    );
};

export default Navbar;